import { defineStore } from "pinia";
import { useBaseDataStore } from "./baseData";
import { baseYearRange } from "@/assets/baseTypes.js";

export const useInterfaceStore = defineStore("interface", {
    state: () => ({
        donorName: ref(null),
        recipientName: ref(null),
        // define categories as a map of objects with the category name as key and the value is an object with the flag enabled in true or false
        categoriesFilter: ref(new Map()),
        minYear: ref(baseYearRange[0]),
        maxYear: ref(baseYearRange[1]),
        sliderYears : ref(baseYearRange),
        flowTypes: ref([
            {label: 'Donors', active: true},
            {label: 'Categories', active: true},
            {label: 'Recipients', active: true}
        ]),
         mapScaleSwitchBool: true,

        loaded:false
        
    }),
    getters: {
        isFilterActive(state) {
            // return true if at least one category is false
            return Array.from(state.categoriesFilter.values()).some((value) => value === false);
        },
        activeCategories(state) {
            // categoriesFilter is a map key: category name, value: true or false return an array of the categories that are true
            return [...state.categoriesFilter].filter(([key, value]) => value === true).map(([key, value]) => key);
        },
        activeFilterKeys(state) {
            return [...state.categoriesFilter].filter(([key, value]) => value === true).map(([key, value]) => key);
        },
        isYearFilterActive(state) {
            return (state.sliderYears[0] != state.minYear || state.sliderYears[1] != state.maxYear)
        },
        isAnyFilterActive(state) {
            return ( state.isYearFilterActive || state.isFilterActive)
        }

    },
    actions: {
        // this action read all the categories from the baseData store and create a new array of objects with the flag enabled in true or false
        // depending if the category is selected or not
        init() {
            if (this.loaded) return
            const baseDataStore = useBaseDataStore();
            const categories = baseDataStore.allCategories;
            categories.forEach((category) => {
                this.categoriesFilter.set(category._id,  true );
            })
            this.loaded = true

        },
        disableAllCategories() {
            this.categoriesFilter.forEach((value, key) => {
                this.categoriesFilter.set(key, false);
            })
        },
        enableAllCategories() {
            this.categoriesFilter.forEach((value, key) => {
                this.categoriesFilter.set(key, true);
            })
        },
        resetAll(){
            this.reset();
            this.resetYearFilter();
        },
        reset() {
            this.donorName = null;
            this.recipientName = null;
            this.categoriesFilter.forEach((value, key) => {
                this.categoriesFilter.set(key, true);
            })
        },
        resetYearFilter() {
            this.sliderYears = [this.minYear, this.maxYear];
        }

    }
})



    